import { render, staticRenderFns } from "./ServiceCharge.vue?vue&type=template&id=92d30c92&"
import script from "./ServiceCharge.vue?vue&type=script&lang=js&"
export * from "./ServiceCharge.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCharge.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VDialog,VRow,VTextField})
